import { enc, mode, pad, AES, lib } from 'crypto-js';

export default class StringEncryptionService {
    static iv = lib.WordArray.create(new Uint8Array(16));
    static privateKey = "d3fbc9128e7a4d28a19ac34e2f68c7fa";

    encryptString(plainText) {

        const encrypted = AES.encrypt(plainText, enc.Utf8.parse(StringEncryptionService.privateKey), {
            iv: StringEncryptionService.iv,
            mode: mode.CBC,
            padding: pad.Pkcs7,
        });

        return encrypted.toString();
    }
}
